import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import {
    UserRecommendationsGrid,
    TWO_TOWER_MODEL_TRIGGER,
} from 'dibs-personalized/exports/UserRecommendationsGrid.ts';
import { useCurrency } from 'dibs-buyer-layout/exports/useCurrency.tsx';

import { useHomePageContext } from '../HomePageContext.tsx';
import { useIsExpand2TowerRecsTestVariant } from '../helpers/expand2TowerRecsTestHelpers.ts';

import { type HpSharedUserRecommendations_user$key } from './__generated__/HpSharedUserRecommendations_user.graphql.ts';

const userFragment = graphql`
    fragment HpSharedUserRecommendations_user on User
    @argumentDefinitions(
        recommendationType: { type: "UserRecommendationType!", defaultValue: PERSONALIZED }
    ) {
        ...UserRecommendationsGrid_user @arguments(recommendationType: $recommendationType)
    }
`;

type HpSharedUserRecommendationsProps = {
    user: HpSharedUserRecommendations_user$key | null;
};

export const HpSharedUserRecommendations: FC<HpSharedUserRecommendationsProps> = ({
    user: userRef,
}) => {
    const user = useFragment(userFragment, userRef);
    const { isMobile, isTablet, isTrade, priceBookName } = useHomePageContext();
    const { currency } = useCurrency();
    const isExpand2TowerRecsTestVariant = useIsExpand2TowerRecsTestVariant();

    return (
        <UserRecommendationsGrid
            user={user}
            trackingTrigger={TWO_TOWER_MODEL_TRIGGER}
            isMobile={isMobile}
            isTablet={isTablet}
            isTrade={isTrade}
            priceBookName={priceBookName}
            dataTn="hp-user-recommendations"
            currency={currency}
            autoLoadMore={isExpand2TowerRecsTestVariant}
        />
    );
};
